<template>
  <div class="login--inner">
    <div class="login--content">
      <h2>LOGIN</h2>
      <form
        class="form-con"
        :class="{'data-loading': showDataLoading }"
        @submit.prevent="handleLoginResult"
      >
        <div class="form-items">
          <div class="form-data">
            <div class="input-wrap">
              <input
                placeholder="username"
                v-model="user.u"
              />
            </div>
          </div>
        </div>

        <div class="form-items">
          <div class="form-data">
            <div class="input-wrap">
              <input
                placeholder="password"
                v-model="user.p"
                type="password"
              />
            </div>
          </div>
        </div>

        <div class="form-items form__item--btn">
          <button
            :disabled="!user.u || !user.p"
            class="btn--login"
          >
            login
          </button>

          <div
            v-if="status === 404 || status === 500"
            class="login-error"
          >
            Invalid credentials.
          </div>
        </div>
      </form>
    </div>

    <BaseModal
      :activate="displayModal"
      :title="modalTitle"
    >
      <template #body>
        <div class="content">
          <CopyData
            v-if="ipAddress"
            :display="`<p>${ipAddress}</p>`"
            :value="ipAddress"
          />
        </div>
        <button
          class="btn--default"
          @click="handleRedirect()"
        >
          {{ translate(translations, 'OK') }}
        </button>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import axios from 'axios'

import { isSuperAdmin } from '@/assets/js/mixins/base/isSuperAdmin'
import translations from '@/assets/js/translations/login/index'

import BaseModal from '@/components/base/Modal'
import CopyData from '@/components/base/CopyData'

export default {
  name: 'login',

  components: {
    BaseModal,
    CopyData
  },

  data () {
    return {
      user: { u: '', p: '' },
      userIsLoggedIn: false,
      logMessage: '',
      showDataLoading: false,
      adminIp: null,
      displayModal: false,
      modalTitle: `
        <h2>${this.translate(translations, 'your_ip_address')}</h2>
        <h3>(${this.translate(translations, 'when_clicked_copied_to_clipboard')})</h3>
      `
    }
  },

  mixins: [ isSuperAdmin ],

  async created () {
    window.localStorage.token = ''
  },

  computed: {
    ...mapState('logins', ['token', 'status']),

    isLoggedIn () {
      return this.userIsLoggedIn
    },

    ipAddress () {
      return this.adminIp
    }
  },

  methods: {
    ...mapActions('logins', { log: 'checkLog', getSuperAdminInfo: 'getInfo' }),

    async handleLoginResult () {
      this.showDataLoading = true
      await this.log(this.user)

      if (this.token && (this.status === 200 || this.status === 202)) {
        this.showDataLoading = false
        window.localStorage.token = this.token
        axios.defaults.headers.common['Authorization'] = `Bearer ${window.localStorage.token}`

        let arrToken = window.localStorage.token.split('.')
        let token = JSON.parse(atob(arrToken[1]))
        window.localStorage.setItem('permission', JSON.stringify(token.permission))

        this.showModal()
      } else {
        this.logMessage = 'login unsuccessful!'
      }
    },

    async showModal () {
      const ipRequest = await this.getSuperAdminInfo()
      this.adminIp = ipRequest
      this.displayModal = true
    },

    handleRedirect () {
      this.logMessage = 'login successful!'
      this.$router.push({ path: '/admin-list/all' })
    }
  }
}
</script>
<style>
  .log_message {
    text-align: center;
  }
</style>
